import React, { useState, useEffect, createContext } from "react";
import { SpinTheWheelService } from "../services";

// api services
// import { SpinTheWheelService } from "../services";
const getToken = () => JSON.parse(localStorage.getItem("token"));

const SpinTheWheelContext = createContext({});

const Provider = ({ children }) => {
  const [spinTheWheelData, setSpinTheWheelData] = useState();
  const [gameStatus, setGameStatus] = useState();
  const [itemWon, setItemWon] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionResponseData, setSubmissionResponseData] = useState();
  const [submissionError, setSubmissionError] = useState();

  useEffect(() => {
    getSpinTheWheel();
  }, []);

  return (
    <SpinTheWheelContext.Provider
      value={{
        getSpinTheWheel,
        spinTheWheelData,
        getGameStatus,
        gameStatus,
        setSpinTheWheelData,
        itemWon,
        setItemWon,
        submitReward,
        isSubmitting,
        submissionResponseData,
        submissionError,
        submitOrderLocation,
        setSubmissionResponseData,
        redeemOrder,
      }}
    >
      {children}
    </SpinTheWheelContext.Provider>
  );

  async function getSpinTheWheel() {
    try {
      const token = getToken();
      const resp = await SpinTheWheelService.getSpinTheWheel(token);
      const { success, data } = resp;
      if (success) {
        setSpinTheWheelData(data);
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  }

  async function getGameStatus() {
    try {
      const token = getToken();
      const data = await SpinTheWheelService.getGameStatus(token);
      if (data) {
        setGameStatus(data);
      }
    } catch (e) {
      console.log(e);
    } finally {
    }
  }

  async function submitReward(code) {
    try {
      setIsSubmitting(true);
      setSubmissionError(null);
      setSubmissionResponseData(null);
      const token = getToken();
      const data = await SpinTheWheelService.submitRewardCode(token, code);
      if (data) {
        setSubmissionResponseData(data);
      }
    } catch (e) {
      console.log(e);
      setSubmissionError(e);
    } finally {
      setIsSubmitting(false);
      getSpinTheWheel();
    }
  }

  async function submitOrderLocation(orderData) {
    try {
      const token = getToken();
      await SpinTheWheelService.submitOrderLocation(token, orderData);
      setSubmissionResponseData(null);
      getSpinTheWheel();
    } catch (e) {
      console.log(e);
    } finally {
    }
  }

  async function redeemOrder(orderId, callback) {
    try {
      const token = getToken();
      const data = await SpinTheWheelService.redeemReward(token, orderId);
      callback(data);
    } catch (e) {
      callback({ success: false, message: e?.response?.data?.message || e?.message || e?.data?.message })
    } finally {
    }
  }
};

SpinTheWheelContext.ProviderWrapper = Provider;

export default SpinTheWheelContext;